// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customCursor_XXM3E{align-items:center;background:transparent;border-radius:50%;display:flex;height:75px;justify-content:center;left:50%;opacity:0;pointer-events:none;position:fixed;top:0;transform:translate(-50%,-50%);visibility:hidden;width:75px}.customCursor_XXM3E:focus{outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customCursor": "customCursor_XXM3E"
};
module.exports = ___CSS_LOADER_EXPORT___;
